var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 1116,
    viewBox: "0 0 860 1116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_625_461",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 860,
    height: 1116
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M860 0H0V1116H860V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_625_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.999 1059.55C757.105 1059.55 787.997 1028.96 787.997 991.228C787.997 953.494 757.105 922.903 718.999 922.903C680.892 922.903 650 953.494 650 991.228C650 1028.96 680.892 1059.55 718.999 1059.55Z",
    fill: "url(#paint0_linear_625_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.026 1206.16C806.896 1206.16 857.052 1156.5 857.052 1095.23C857.052 1033.96 806.896 984.298 745.026 984.298C683.156 984.298 633 1033.96 633 1095.23C633 1156.5 683.156 1206.16 745.026 1206.16Z",
    fill: "url(#paint1_linear_625_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.5 198.048C866.962 198.048 933 132.654 933 51.9876C933 -28.6793 866.962 -94.0728 785.5 -94.0728C704.038 -94.0728 638 -28.6793 638 51.9876C638 132.654 704.038 198.048 785.5 198.048Z",
    fill: "url(#paint2_linear_625_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 169.331C630.441 169.331 707 93.5189 707 1.52588e-05C707 -93.5189 630.441 -169.331 536 -169.331C441.559 -169.331 365 -93.5189 365 1.52588e-05C365 93.5189 441.559 169.331 536 169.331Z",
    fill: "url(#paint3_linear_625_461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.99989 961.523C99.0682 961.523 181 880.39 181 780.309C181 680.227 99.0682 599.095 -1.99989 599.095C-103.068 599.095 -185 680.227 -185 780.309C-185 880.39 -103.068 961.523 -1.99989 961.523Z",
    fill: "url(#paint4_linear_625_461)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_625_461",
    x1: 581.001,
    y1: 991.228,
    x2: 856.996,
    y2: 991.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#61BEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#367780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_625_461",
    x1: 520.974,
    y1: 1095.23,
    x2: 969.077,
    y2: 1095.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A5C7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#52AEB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_625_461",
    x1: 554,
    y1: 280,
    x2: 1057,
    y2: -54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A5C7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#367780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_625_461",
    x1: 194,
    y1: 0,
    x2: 878,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A5C7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74991,
    stopColor: "#367780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_625_461",
    x1: -368,
    y1: 780.309,
    x2: 364,
    y2: 780.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#84B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#367780"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.1eb0588d47c45ef4a489c711600a21a5.svg";
export { ForwardRef as ReactComponent };